import { SearchUserEnriched } from 'lib-search-types';
import { User } from 'lib-shared-types-api';

import { AwayStatus } from 'apis/presence';
import { AddFavoritesDropdown } from 'components/addFavoritesDropdown';
import { PresenceRowSelection } from 'components/presence/components/presenceListItem';
import { PresenceSection } from 'components/presence/components/presenceSection';
import { PresenceSectionSkeleton } from 'components/presence/components/presenceSectionSkeleton';
import { SidebarIconButton } from 'components/presence/components/sidebarIconButton';
import { CollapsedSections } from 'components/presence/hooks/useCollapsedSections';
import { useFavoriteAgents } from 'utils/useFavoriteAgents';

type FavoritesPresenceListSectionProps = {
  profile: User;
  awayStatuses: AwayStatus[];
  members: SearchUserEnriched[];
  loading: boolean;
  selection: PresenceRowSelection;
  onDropdownOpenChange: (isOpen: boolean) => void;
  collapsedSections: CollapsedSections;
};

export const FavoritesPresenceListSection = ({
  profile,
  awayStatuses,
  members,
  loading,
  selection,
  onDropdownOpenChange,
  collapsedSections,
}: FavoritesPresenceListSectionProps): JSX.Element => {
  const { removeFavorite } = useFavoriteAgents();

  if (loading) {
    return <PresenceSectionSkeleton />;
  }

  return (
    <PresenceSection
      id="favorites"
      title="Favorites"
      count={members.length}
      members={members}
      profile={profile}
      awayStatuses={awayStatuses}
      selection={selection}
      collapsedSections={collapsedSections}
      renderRowAction={(member) =>
        member.id !== profile.id && (
          <SidebarIconButton
            icon="star-full"
            label="Unfavorite agent"
            hideTooltip
            onClick={(event) => {
              event.stopPropagation();
              removeFavorite(member.id);
            }}
          />
        )
      }
      actions={
        <AddFavoritesDropdown
          trigger={<SidebarIconButton icon="star" label="Add favorites" />}
          onOpenChange={onDropdownOpenChange}
        />
      }
    />
  );
};
